<template>
<section class="formContact">
  <h3 class="formContact__title">Напишите нам</h3>
  <p class="formContact__title--sub">Вы можете обратиться к нам по любым вопросам, связанным с работой сервиса Renta</p>
  <v-form ref="form-contacts" @submit="onForm($event)" class="formContact__form" novalidate="true">
    <div class="formContact__group">
      <div class="formContact__group--input">
        <div class="formContact__group--label">Как к Вам обращаться <span>*</span></div>
        <v-text-field
          v-model="form.Name"
          label=""
          class="form__block--name"
          outlined
          :rules="[rules.required]"
        ></v-text-field>
      </div>
      <div class="formContact__group--input">
        <div class="formContact__group--label">Номер Вашего телефона <span>*</span></div>
        <v-text-field
          v-model="form.Phone"
          label=""
          class="form__block--phone"
          v-mask="['+7(###) ###-##-##']"
          placeholder="+7(___) ___-__-__"
          outlined
          :rules="[rules.required, rules.phone, rules.phoneMin17]"
        ></v-text-field>
      </div>
      <div class="formContact__group--input">
        <div class="formContact__group--label">Ваш e-mail для связи <span>*</span></div>
        <v-text-field
          v-model="form.Email"
          label=""
          class="form__block--mail"
          placeholder="E-mail"
          outlined
          :rules="[rules.email]"
        ></v-text-field>
      </div>
      <div class="formContact__group--input">
        <div class="formContact__group--label">Название компании </div>
        <v-text-field
          v-model="form.Company"
          label=""
          class="form__block--null"
          outlined
        ></v-text-field>
      </div>
    </div>
    <div class="formContact__comment">
      <div class="formContact__group--label">Ваш вопрос или сообщение <span>*</span></div>
      <v-textarea
        v-model="form.Text"
        placeholder="Введите текст"
        outlined
        :rules="[rules.required]"
      >
      </v-textarea>
    </div>

    <div class="formContact__confirm">
      <v-checkbox v-model="agreeForm"></v-checkbox>
      <div v-html="agreeText"></div>
    </div>
    <button
      class="formContact__submit button button--orange"
      :disabled="!agreeForm"
      v-on:click="onForm($event)">
      Отправить заявку
    </button>
  </v-form>
</section>
</template>

<script>
import axios from 'axios';
import { validateInn } from '../../../functions/validate';

export default {
  name: 'FormContact',
  data() {
    return {
      agreeForm: false,
      agreeText: 'Я даю <a href="https://static.ofd.ru/ofdru/politic/consent_pd.pdf" class="formContact__confirm--link" target="_blank">согласие</a> на обработку моих персональных данных в&nbsp;соответствии с&nbsp;<a href="https://static.ofd.ru/ofdru/politic/privacy_policy.pdf" class="formContact__confirm--link" target="_blank">Политикой конфиденциальности</a>.',
      form: {
        Name: '',
        Email: '',
        Phone: '',
        Company: '',
        Text: ''
      },
      rules: {
        required: value => !!value || 'Обязательное поле',
        // eslint-disable-next-line
        email: value => /^[0-9a-z-_а-яА-ЯёЁ\.]+\@[0-9a-z-а-яА-ЯёЁ]{2,}\.[a-zа-яА-ЯёЁ]{2,}/i.test(value) || 'Неверный формат E-Mail',
        phone: value => /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm.test(value) || 'Неверный формат телефона',
        phoneMin17: value => value.length === 17 || 'Неверный формат телефона',
        inn: value => {
          const validateInnResult = validateInn(value, {});
          return validateInnResult || 'Введён не верный ИНН';
        },
      },
    }
  },
  methods: {
    onForm: function (e) {
      e.preventDefault();

      if (this.$refs['form-contacts'].validate()) {
        axios
          .post('/api/renta/landing/store', {
            FIO: this.form.Name,
            Email: this.form.Email,
            Phone: this.form.Phone,
            Message: this.CreatMessage(),
          })
          .then(() => {
            this.$modal.show('form-modal-contact', {step: 'true'});
          })
          .catch(() => {
            this.$modal.show('form-modal-contact', {step: 'error'});
          });
      }
    },
    CreatMessage () {
      return `Компания: ${this.form.Company} \n` + `Сообщение: ${this.form.Text}`;
    }
  }
}
</script>

<style src="./component.scss" scoped lang="scss"/>
